/**
 * The row above a page section's card: the section title, its meta chip, and
 * the section's actions.
 *
 * Shared because Planning and Financials carried byte-identical copies of this
 * block — and the one thing the copies could not share was height. Planning's
 * row holds `PlanViewSwitcher`, a 32px button inside a 2px track, so it stood
 * 36px tall against Financials' bare 32px button. The card below therefore
 * started 4px lower on Planning, and the header visibly jumped as you moved
 * between the two tabs.
 *
 * `minHeight` is the switcher's height, because the switcher is the tallest
 * control a section header holds. A taller one has to raise this — which is
 * the point of it being in one place.
 */
export const SECTION_HEADER_MIN_HEIGHT_PX = 36;

export const SECTION_HEADER_SX = {
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  flexWrap: 'wrap',
  minHeight: `${String(SECTION_HEADER_MIN_HEIGHT_PX)}px`,
  // 2026-10-01 (the pilot's ask): a little more air above the row, less down to
  // the card — 12px under the project header (its `mb: -1` + this), 8px below.
  mt: 0.5,
  mb: 1,
} as const;
